export enum LoanDashboardModules {
  All,
  Pending,
  Agreement,
  FinalDisbursement,
  AllRepayment,
  PendingRepayment
}
